export const REFRESH_INTERVAL = 60000; // Interval duration (60s) in milliseconds
export const REQUEST_RETRIES_IF_FAIL = 3;
export const MAX_PHONE_DIGITS = 10;
export const OTP_LENGTH = 6;
export const NUM_OF_DECIMALS = 2;
export const HTTP_STATUS_CODES = {
  UNAUTHORIZED: 401,
  SERVER_ERROR: 500,
};
export const MAX_DATE_DIFFERENCE = 365;
export const MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;
